import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import cityCensusByAreaReadAction from './cityCensusByAreaRead.action.json'

const cityCensusByAreaReadDefinition = defineReadAutoAction(
  cityCensusByAreaReadAction,
  'cityCensusByArea',
)

export default cityCensusByAreaReadDefinition
